import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const MONATE = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"]

export const nf0 = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 })
export const nf1 = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 })
export const pf1 = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
  signDisplay: "exceptZero",
})
export const pf0 = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0, signDisplay: "exceptZero" })

/** Sekunden → "8:14" (min:sec). */
export function mmss(sekunden: number): string {
  const t = Math.round(sekunden)
  return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, "0")}`
}

/** Wert einer CSS-Variable (Rampenfarben, Diagrammfarben). */
export function cssVar(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim()
}

/** "rgb(var(--accent))" für SVG-Attribute. */
export function farbe(name: string): string {
  return `rgb(var(--${name}))`
}

/** Relative Helligkeit einer Hex-Farbe (für Text auf Rampenfarben). */
export function helligkeit(hex: string): number {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex)
  if (!m) return 0.5
  const n = parseInt(m[1], 16)
  const lin = (c: number) => {
    c /= 255
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
  }
  return 0.2126 * lin((n >> 16) & 255) + 0.7152 * lin((n >> 8) & 255) + 0.0722 * lin(n & 255)
}

/** Saubere Achsenwerte zwischen lo und hi. */
export function niceTicks(lo: number, hi: number, anzahl: number): number[] {
  const span = hi - lo || 1
  const roh = span / Math.max(1, anzahl)
  const p = Math.pow(10, Math.floor(Math.log10(roh)))
  const schritt = [1, 2, 2.5, 5, 10].map((f) => f * p).find((s) => span / s <= anzahl) ?? 10 * p
  const a = Math.floor(lo / schritt) * schritt
  const b = Math.ceil(hi / schritt) * schritt
  const ticks: number[] = []
  for (let v = a; v <= b + schritt / 2; v += schritt) ticks.push(Math.round(v * 1000) / 1000)
  return ticks
}
